export default (string) => {
  return string.split('').reverse().join('')
}
